module.exports = __webpack_public_path__ + "img/fxwalletRT.53087123.jpg";